import React, { useState, useEffect } from 'react';

import Header from '../Header.js';
import SortReportsBox from '../boxes/SortReportsBox.js';
import MDReportsBox from '../boxes/MDReportsBox.js';
import HomeGraphsBox from '../boxes/HomeGraphsBox.js';
import BoxTabs from '../boxes/BoxTabs.js';
import Footer from '../Footer.js';

const ServiceHome = ({ user }) => {
    
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [showMDTab, setShowMDTab] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1600); // screen width cutoff
        };
    
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (user?.uid === 14) {
            setShowMDTab(true);
        }
    }, []);

    // Define tabs configuration
    const tabs = [
        {
            label: "Last Week of Responses",
            component: HomeGraphsBox,
            props: { user: user }
        },
        {
            label: "Latest Reports", 
            component: SortReportsBox,
            props: { user: user }
        }
    ];

    if (showMDTab) {
        tabs.unshift({
            label: "DR. MASIEWICZ",
            component: MDReportsBox,
            props: { user: user }
        });
    }

    return (
        <div>
            <Header 
                user={user} 
                buttonsVisible={{
                    agencySettingsButton: true,
                    medicInfoButton: true,
                    qiButton: user.subscriptions.includes('CADMUS_QI'),
                    demoTestButton: user.subscriptions.includes('ADMIN'),
                    agencyListButton: user.subscriptions.includes('ADMIN')
                }}
                pageTitle="Home"
            />
            <div className='box-spacer'/>
            <BoxTabs 
                tabs={tabs}
                defaultTabIndex={0}
                isSmallScreen={isSmallScreen}
            />
            {/* <SortReportsBox user={user} isSmallScreen={isSmallScreen}/> */}
            <Footer />
        </div>
    );
};

export default ServiceHome;